import React, { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Hero from './sections/Hero';
import NiveisDeEnsino from './sections/NiveisDeEnsino';
import Depoimentos from './sections/Depoimentos';
import Institucional from './sections/Institucional';

const DesktopVersion = () => {
  useEffect(() => {
    // Update the document title
    document.title = "Conheça o Fazer Crescer";
    
    // Optional: Restore the original title when component unmounts
    return () => {
      document.title = "React App"; // or whatever your default title is
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="desktop-view">
      <Layout showHeader={false}>  
        <Hero />
        <NiveisDeEnsino />
        <Depoimentos />
        <Institucional />
      </Layout>
    </div>
  );
};

export default DesktopVersion; 